import { Routes } from '@angular/router';
import {NgxPermissionsGuard} from 'ngx-permissions';

import {permissions } from '../../permissions';
import {CustomersComponent } from './customers.component';
import {CustomerEditComponent} from './customer-edit/customer-edit.component';
import {AuthGuardService as AuthGuard} from './../../auth-guard.service';
import { TpNewCustomerComponent } from '../trading-partners/tp-new-customer/tp-new-customer.component';

export const routes: Routes = [{
    path: 'customers',
    component: CustomersComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Customers',
        permissions: {
            only: [permissions.CUSTOMERS_READ]
        }
    },
}, {
    path: 'customers/add/:id/:CO1_ID',
    component: TpNewCustomerComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Add Customer',
        permissions: {
            only: [permissions.CUSTOMERS_ADD]
        }
    }
}, {
    path: 'customers/edit/:id/:CO1_ID',
    component: TpNewCustomerComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Edit Customer',
        permissions: {
            only: [permissions.CUSTOMERS_EDIT]
        }
    }
}
];


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/customers/customers.routing.ts